import copy from 'copy-to-clipboard';

/**
 * Cross-browser clipboard copy using 'copy-to-clipboard' package.
 * It handles iOS quirks natively and synchronously.
 * Returns a Promise<boolean> to maintain backward compatibility with our codebase.
 */
const copyToClipboard = (text) => {
  return new Promise((resolve) => {
    try {
      const success = copy(text, {
        debug: false,
        message: 'Press #{key} to copy',
      });
      resolve(success);
    } catch (e) {
      console.warn('[copyToClipboard] failed:', e);
      resolve(false);
    }
  });
};

export default copyToClipboard;
